import { combineReducers } from 'redux';
import { apiReducerFactory } from './apiReducerFactory';

import * as booking from '../booking/booking/action-types';
import * as bookingExtras from '../booking/extras/action-types';
import * as bookingForm from '../booking/form/action-types';
import * as bookingPayment from '../booking/payment/action-types';

import * as previousBooking from '../booking/previousBooking/action-types';

import * as dataCachedAvail from '../data/cachedAvail/action-types';
import * as dataFilters from '../data/filters/action-types';
import * as dataOperators from '../data/operators/action-types';
import * as dataParkDetails from '../data/park/details/action-types';
import * as dataParkResults from '../data/park/results/action-types';
import * as dataParkReviews from '../data/park/reviews/action-types';
import * as dataParks from '../data/parks/action-types';
import * as dataRegions from '../data/regions/action-types';
import * as dataUnitTypes from '../data/unitTypes/action-types';

import * as init from '../init/action-types';

import * as searchForm from '../search/form/action-types';
import * as searchResults from '../search/results/action-types';

import * as user from '../user/action-types';

// List all actions in a single array
const actions = [
  booking.CREATE_BOOKING,
  booking.GET_DEPOSIT,
  booking.SET_DISCOUNT_CODE,
  previousBooking.PREVIOUS_BOOKING,
  bookingExtras.GET_EXTRAS,
  bookingExtras.SET_EXTRAS,
  bookingForm.SET_PARTY_DETAILS,
  bookingPayment.PRE_PAYMENT,
  bookingPayment.POST_PAYMENT,
  dataFilters.GET_FILTERS,
  dataOperators.GET_OPERATORS,
  dataParks.GET_PARKS,
  dataParkDetails.GET_PARK_DETAILS,
  dataParkResults.GET_PARK_RESULTS,
  dataParkReviews.GET_PARK_REVIEWS,
  dataRegions.GET_OPERATOR_REGIONS,
  dataRegions.GET_REGIONS,
  dataUnitTypes.GET_EXTRA_DATA,
  dataCachedAvail.GET_CACHED_AVAIL_DATA,
  init.GET_INIT_DATA,
  searchForm.START_SEARCH,
  searchResults.GET_RESULTS,
  user.CREATE_USER,
];

// Create the reducers object using map and reduce
const reducers = Object.fromEntries(actions.map((action) => [action, apiReducerFactory(action)]));

// Combine reducers
export default combineReducers(reducers);
